const OfferLineBreakdown = {
  paid_and_free: '{{paidQuantity}} × {{price}} betaald · {{freeQuantity}} × gratis',
  all_free: '{{freeQuantity}} × gratis',
};

export default OfferLineBreakdown;
